import { priceFormat } from '~/shared/lib/utils'
import {
  AsyncGridColumns,
  ColumnDate,
  ColumnLink,
  ColumnValue,
} from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.request number',
    field: 'number',
    minWidth: 140,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.number}</ColumnLink>,
  },
  {
    headerName: 'column.status',
    field: 'status',
    renderCell: ({ value }) => (
      <ChipStatus label={value.label} variant={value.color} />
    ),
    minWidth: 140,
  },

  {
    headerName: 'column.date and time',
    field: 'createdAt',
    renderCell: ({ row }) => (
      <ColumnDate type='dateTime' value={row.createdAt} />
    ),
    minWidth: 200,
  },
  {
    headerName: 'column.driver',
    field: 'driver.fullName',
    renderCell: ({ row }) => (
      <ColumnLink to={`/drivers/${row.driverId}`}>
        {row.driverFullName}
      </ColumnLink>
    ),
    minWidth: 240,
  },
  {
    headerName: 'column.driver phone',
    field: 'driverPhone',
    sortable: false,
    minWidth: 160,
  },
  {
    headerName: 'column.car',
    field: 'car.plateNumber',
    renderCell: ({ row }) => (
      <ColumnLink to={`/cars/${row.carId}`}>{row.carPlateNumber}</ColumnLink>
    ),
    minWidth: 140,
  },
  {
    headerName: 'column.model',
    field: 'carModel',
    sortable: false,
    minWidth: 140,
  },
  {
    headerName: 'column.subdivision',
    field: 'subdivision.title',
    renderCell: ({ row }) => <ColumnValue>{row.subdivisionName}</ColumnValue>,
    minWidth: 200,
  },
  {
    headerName: 'column.request type',
    field: 'appealType.title',
    renderCell: ({ row }) => <ColumnValue>{row.appealType}</ColumnValue>,
    minWidth: 240,
  },
  {
    headerName: 'column.amount',
    field: 'amount',
    renderCell: ({ row }) => (
      <ColumnValue>{priceFormat(row.amount)}</ColumnValue>
    ),
    minWidth: 180,
  },
  {
    headerName: 'column.initiator',
    field: 'creator.name',
    renderCell: ({ row }) => <ColumnValue>{row.creatorName}</ColumnValue>,
    minWidth: 180,
  },
  {
    headerName: 'column.initiator comment',
    field: 'creatorComment',
    minWidth: 200,
  },
  {
    headerName: 'column.responsible',
    field: 'responsible.name',
    minWidth: 180,
    renderCell: ({ row }) => <ColumnValue>{row.responsibleName}</ColumnValue>,
  },
  {
    headerName: 'column.responsible comment',
    field: 'responsibleComment',
    minWidth: 240,
  },
  {
    headerName: 'column.days in status',
    field: 'daysInStatus',
    minWidth: 200,
  },
]
